import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import {
  getDeletePlatformPartnersURL,
  getloadPlatformPartnersURL,
  getArchivePlatformPartnersURL,
  getRestorePlatformPartnersURL
} from "../utils/constants/apiEndPoints";
import { commonErrMsg } from "../locales/en";

// Initial state
const initialState = {
  loading: false,
  platformPartnerAppData: [],
  error: null
};

// Slice
const platformPartnerAppSlice = createSlice({
  name: "platformPartnerApp",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get list
    builder
      .addCase(platformPartnerAppListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(platformPartnerAppListThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(platformPartnerAppListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        showToast(action.payload, showToastType.error);
      })
      .addCase(platformPartnerDeleteAppListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(platformPartnerDeleteAppListThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(platformPartnerDeleteAppListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        showToast(action.payload, showToastType.error);
      })
      .addCase(platformPartnerArchiveThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(platformPartnerArchiveThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(platformPartnerArchiveThunk.rejected, (state, action) => {
        state.loading = false;
        showToast(action.payload, showToastType.error);
      })
      .addCase(platformPartnerRestoreThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(platformPartnerRestoreThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(platformPartnerRestoreThunk.rejected, (state, action) => {
        state.loading = false;
        showToast(action.payload, showToastType.error);
      });
  }
});

// Thunk:Get platform partner app list
export const platformPartnerAppListThunk = createAsyncThunk(
  "platformPartnerApp/getList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getloadPlatformPartnersURL, {
        params: payload
      });
      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        commonErrMsg.item7;
      return rejectWithValue(message);
    }
  }
);

// Thunk: Delete
export const platformPartnerDeleteAppListThunk = createAsyncThunk(
  "platformPartnerApp/delete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.delete(
        getDeletePlatformPartnersURL(Number(payload))
      );
      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        commonErrMsg.item7;
      return rejectWithValue(message);
    }
  }
);

// Thunk: Archive
export const platformPartnerArchiveThunk = createAsyncThunk(
  "platformPartnerApp/archive",
  async (id, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getArchivePlatformPartnersURL(id)
      );
      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        commonErrMsg.item7;
      return rejectWithValue(message);
    }
  }
);

// Thunk: Restore
export const platformPartnerRestoreThunk = createAsyncThunk(
  "platformPartnerApp/restore",
  async (id, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getRestorePlatformPartnersURL(id)
      );
      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        commonErrMsg.item7;
      return rejectWithValue(message);
    }
  }
);

export default platformPartnerAppSlice.reducer;
